/**
 * COMPANY
 */
import 'es6-promise/auto';
import 'picturefill';
import { breakpoint, containerID } from '@/_modules/utils/variables';
// vue
import Vue from 'vue';
import store from '@/_modules/stores';
import Loading from '@/_components/loading.vue';
import TransitionCover from '@/_components/transition-cover.vue';
//import GlobalHeader from '@/_components/global-header.vue';
//import GlobalFooter from '@/_components/global-footer.vue';
//import GlobalNavi from '@/_components/global-navi.vue';
import EnKv from '@/_components/en-kv.vue';
import EnMember from '@/_components/en-member.vue';
import CommonPlugin from '@/_modules/common/common-plugin'
Vue.use(CommonPlugin);

import Gmap from '@/_modules/common/Gmap';
import scrollManager from '@/_modules/common/scrollManager';
import subBg from '@/_modules/common/subBg';
window.$scrollManager = scrollManager;

export default class AppKr {
  /**
   * コンストラクタ
   */
  constructor() {
    // クラス名
    this.name = 'AppKr';
    this.init();
  }

  /**
   * 初期
   */
  init() {
    new subBg();

    this.vue = new Vue({
      components: {
        Loading,
        TransitionCover,
        EnKv,
        EnMember
      },
      data() {
        return {
          ispc: false,
          isLoaded: false,
          isState: '',
          urls: {},
          ticker: [],
        }
      },
      el: `#${containerID}`,
      store,
      computed: {
      },
      created() {
        this.$store.commit('setDevice');
      },
      mounted() {

        this.$_anchorFromUrl();

        this.urls = this.$store.getters.getUrls;

        new Gmap();

        $scrollManager.init();

        this.$nextTick(this.start);
      },
      methods: {
        start() {
          this.$store.commit('setShowCoverOut', false);
        },
        showLoading() {
          this.$store.commit('setShowLoading', true);
        },
        hideLoading() {
          this.$store.commit('setShowLoading', false);
        }
      }
    });
  }
}
